
function makeViewLoader<
    L extends Record<string, (...args: any[]) => any>
>(loaders: L) {
    return <K extends keyof L>(
        key: K,
        ...params: Parameters<L[K]>
    ): ReturnType<L[K]> => {
        return loaders[key](...params);
    };
}

export const useViewLoaders = <V extends Record<string, (...args: any[]) => any>>(views: V) => {
    return makeViewLoader(views);
};
